var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"value":_vm.selectedTabIndex}},_vm._l((_vm.tabs),function(tab,index){return _c('v-tab',{key:index,staticStyle:{"line-height":"1.5","font-size":"14px"},on:{"click":function($event){return _vm.updateTab(tab.key)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }